import { http } from "@/api/http";
import type {
  CompanyWishlistResponse,
  InboxResponse,
  InboxSyncResponse,
  WishlistRemoveResponse,
  WishlistSaveResponse,
  WishlistTrackingResponse,
} from "@/types/inboxWishlist";

export const MICROSOFT_OAUTH_START_PATH = "/oauth/microsoft/start";

export async function getInbox(signal?: AbortSignal): Promise<InboxResponse> {
  const response = signal
    ? await http.get<InboxResponse>("/inbox", { signal })
    : await http.get<InboxResponse>("/inbox");
  return response.data;
}

export async function syncInbox(
  signal?: AbortSignal,
): Promise<InboxSyncResponse> {
  const response = signal
    ? await http.post<InboxSyncResponse>("/inbox/sync", {}, { signal })
    : await http.post<InboxSyncResponse>("/inbox/sync", {});
  return response.data;
}

export async function getCompanyWishlist(
  signal?: AbortSignal,
): Promise<CompanyWishlistResponse> {
  const response = signal
    ? await http.get<CompanyWishlistResponse>("/company-wishlist", { signal })
    : await http.get<CompanyWishlistResponse>("/company-wishlist");
  return response.data;
}

export async function addWishlistCompany(
  company: string,
  signal?: AbortSignal,
): Promise<WishlistSaveResponse> {
  const response = signal
    ? await http.post<WishlistSaveResponse>(
        "/company-wishlist",
        { company },
        { signal },
      )
    : await http.post<WishlistSaveResponse>("/company-wishlist", { company });
  return response.data;
}

export async function removeWishlistCompany(
  wishlistId: string,
  signal?: AbortSignal,
): Promise<WishlistRemoveResponse> {
  const url = `/company-wishlist/${encodeURIComponent(wishlistId)}`;
  const response = signal
    ? await http.delete<WishlistRemoveResponse>(url, { signal })
    : await http.delete<WishlistRemoveResponse>(url);
  return response.data;
}

export async function trackWishlistCompany(
  wishlistId: string,
  signal?: AbortSignal,
): Promise<WishlistTrackingResponse> {
  const url = `/company-wishlist/${encodeURIComponent(wishlistId)}/tracking`;
  const response = signal
    ? await http.post<WishlistTrackingResponse>(url, undefined, { signal })
    : await http.post<WishlistTrackingResponse>(url);
  return response.data;
}
